import api from 'api'
import { fetchWithToken } from 'utils'
import { PbxType } from 'utils/constants'
import { DEFAULT_PAGINATION_SIZE } from './constants'

/**
 * Retrieves the list of Pbx
 */
const fetchPbxs = async (query: string, offset = 0, pbxTypes: PbxType[] = []): Promise<any> =>
  fetchWithToken({
    method: 'GET',
    resource: api.pbx,
    useV5: true,
    useVersion: 'v1',
    path: 'pbxs',
    filters: buildFilters(query, offset, pbxTypes),
  })
    .then((response: Response) => (response.status === 200 ? response.json() : null))
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

const buildFilters = (query: string, offset = 0, pbxTypes: PbxType[]) => {
  let filter = `includeUnifiedAdmin=true&limit=${DEFAULT_PAGINATION_SIZE}`

  if (offset >= 0) {
    filter += `&offset=${offset}`
  }

  if (query) {
    filter += `&q=${query}`
  }

  if (pbxTypes && pbxTypes.length > 0) {
    pbxTypes.forEach((type) => (filter += `&type=${type}`))
  }

  return filter
}

export default fetchPbxs
